import { gql } from '@apollo/client';

export const DELETE_GROUP = gql`
	mutation deleteGroup($groupId: ID!) {
		deleteCrewMemberGroup(id: $groupId) {
			group {
				id
			}
		}
	}
`;
